<template>
  <InitialLoader v-if="showInitialLoader" />
  <div
    id="app-content"
    class="flex flex-col min-h-screen"
    :style="{ opacity: appReady ? 1 : 0 }"
  >
    <AppHeader />

    <MobileWarning />

    <main class="flex-1">
      <router-view />
    </main>

    <AppFooter :last-update-time="appState.lastUpdateTime" />

    <LoadingOverlay :visible="appState.isLoading" />
  </div>
  <ToastContainer />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useAppState } from '@/store/app'
import { useAppInit } from '@/composables/useAppInit'

import InitialLoader from '@/components/layout/InitialLoader.vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import MobileWarning from '@/components/layout/MobileWarning.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import LoadingOverlay from '@/components/layout/LoadingOverlay.vue'
import ToastContainer from '@/components/common/ToastContainer.vue'

const { appState } = useAppState()
const { initializeApp } = useAppInit()

const showInitialLoader = ref(true)
const appReady = ref(false)

onMounted(() => {
  if (document.fonts) {
    document.fonts.ready.then(() => {
      document.body.classList.add('fonts-loaded')
      showInitialLoader.value = false
      appReady.value = true
    })
  } else {
    setTimeout(() => {
      document.body.classList.add('fonts-loaded')
      showInitialLoader.value = false
      appReady.value = true
    }, 100)
  }

  setTimeout(() => {
    showInitialLoader.value = false
    appReady.value = true
  }, 3000)

  initializeApp()
})
</script>

<style>
#app-content {
  transition: opacity 0.3s ease-in;
}
</style>
